import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles } from 'lucide-react';
const benefits = ['Protocolos de crisis en tiempo real', 'Tracker de progreso 30 días', 'Sistema premium de sueño profundo', 'Reset completo del sistema nervioso', 'Implementación guiada avanzada'];
export function UpsellSection() {
  return <section className="py-20 bg-beige-light" data-id="element-167">
      <div className="max-w-3xl mx-auto px-6" data-id="element-168">
        <motion.div className="bg-white rounded-3xl p-8 md:p-12 border border-gold/30 shadow-premium relative overflow-hidden" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-169">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-170"></div>

          <div className="text-center mb-8 relative z-10" data-id="element-171">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-beige mb-6 text-gold-dark" data-id="element-172">
              <Sparkles size={24} data-id="element-173" />
            </div>
            <h2 className="text-2xl md:text-3xl font-serif text-navy mb-3" data-id="element-174">
              ¿Querés una implementación más profunda?
            </h2>
            <p className="text-slate" data-id="element-175">
              El sistema avanzado de 30 días para quienes quieren ir más allá.
            </p>
          </div>

          <div className="bg-beige-light/50 rounded-2xl p-6 md:p-8 mb-6 relative z-10" data-id="element-176">
            <h3 className="font-serif text-xl text-navy text-center mb-6 font-medium" data-id="element-177">
              PROTOCOLO PREMIUM DE CALMA TOTAL
            </h3>
            <ul className="space-y-4" data-id="element-178">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-179">
                  <CheckCircle2 size={20} className="text-gold shrink-0 mt-0.5" data-id="element-180" />
                  <span className="text-slate-dark" data-id="element-181">{benefit}</span>
                </li>)}
            </ul>
          </div>

          <p className="text-center text-sm text-slate-light italic relative z-10" data-id="element-182">
            * Disponible como upgrade opcional después de tu compra principal.
          </p>
        </motion.div>
      </div>
    </section>;
}